import React from 'react';
import { Link } from 'react-router-dom';
import styles from './PublicHeader.module.css';

const PublicHeader = () => {
  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <Link to="/" className={styles.logo}>
          <img
            src={`${process.env.PUBLIC_URL}/images/brand/verdekai-linkedin-company-logo.png`}
            alt="VerdeKai"
            className={styles.logoImage}
          />
          <div className={styles.logoText}>
            <span className={styles.brandName}>VerdeKai</span>
            <span className={styles.brandTagline}>Legal Terminal</span>
          </div>
        </Link>
        <nav className={styles.nav}>
          <Link to="/login" className={styles.clientPortal}>
            Client Portal
            <span className={styles.arrow}>&rarr;</span>
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default PublicHeader;
